import { fo_monan_chitiet } from '../../../models/response/dich-vu/food/fo_monan_chitiet';
import { apiClient } from '../../apiClient';
import { BaseCRUDApi } from '../../baseCRUDApi';

export const API_FO_MONAN_CHITIET_PATH = "food/monan-chitiet";

class FoMonAnChiTietApi extends BaseCRUDApi<fo_monan_chitiet> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/food/monan-chitiet`);
	}
}
export const foMonAnChiTietApi = new FoMonAnChiTietApi(API_FO_MONAN_CHITIET_PATH);
